import { getMenuPanelInnerMarkup } from '../../components/menuPanelMarkup';

(function () {
  var script = document.currentScript;
  var html = `<div class="l-header-lower js-header-lower">
      <header id="app-header">
        <a href="/kaiho-biku/" id="logo" class="logo--small l-header-lower-logo">
          <img src="/kaiho-biku/assets/img/map/logo.webp" alt="解放美区 KAIHOBIKU" width="343" height="99">
        </a>
        <div class="l-header-lower-menu">
          <a href="/kaiho-biku/" class="l-header-lower-menu-link" aria-label="サイトトップへ遷移する">
            <img src="/kaiho-biku/assets/img/article/common/icons/icon_map.svg" alt="" width="28" height="28">
            <span class="menu-btn__label">MAP</span>
          </a>
          <button id="menu-btn" aria-label="メニューを開く" class="l-header-lower-menu-button js-header-lower-menu-button">
            <span class="menu-btn__icon"><span></span><span></span><span></span></span>
            <span class="menu-btn__label">MENU</span>
          </button>
        </div>
      </header>
      <div id="menu-overlay" class="js-header-lower-overlay"></div>
      <div id="menu-panel" class="js-header-lower-menu-panel">
        ${getMenuPanelInnerMarkup({ closeButtonClass: 'js-header-lower-menu-close' })}
      </div>
    </div>`;
  script.insertAdjacentHTML('beforebegin', html);
})();
